const siteTheme = {
    site: {
        jot: {
            fontFamily: 'Catamaran, sans-serif',
            listItem: {
                fontSize: 14,
            },
            textArea: {
                fontSize: 30,
            },
            quickActions: {
                iconSize: 18,
                size: 40,
                icon: {
                    maximize: 'maximize',
                    minimize: 'minimize',
                    archive: 'edit-3',
                    delete: 'trash-2',
                    edit: 'edit-2',
                },
            },
            selection: {
                backgroundColor: '#fff4ec',
            },
        },
        stage: {
            height: '56vh',
            margin: '12vh',
            actions: {
                margin: 16,
            },
        },
        aside: {
            scrollbar: {
                width: 8,
            },
            padding: { v: 50 },
            gradient: {
                color: '#fff',
            },
        },
        viewport: {
            height: '80vh',
        },
        addJotAction: {
            icon: {
                size: 40,
                name: 'plus-circle',
            },
            backgroundColor: '#fff',
            boxShadowSize: 16,
        },
    },
};

export default siteTheme;
